"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DraggableRowSource(_ref) {
  var connectDragSource = _ref.connectDragSource;
  return connectDragSource(_react.default.createElement("td", {
    className: "co-table__cell co-table__drag-handle"
  }));
}

DraggableRowSource.propTypes = {
  children: _propTypes.node
};
var _default = DraggableRowSource;
exports.default = _default;